<template>
  <div class="contenedor-cpanel">
    <!-- <Header2/> -->
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Listado de Ventas Entregadas</h1>
        <div class="barra"></div>
      </div>
      <VentasListaCarritoEntregadas
      ></VentasListaCarritoEntregadas>
    </section>
  </div>
</template>

<script>
import VentasListaCarritoEntregadas from '../components/VentasListaCarritoEntregadas.vue'
// import Header2 from '../components/Header2.vue'
export default {
  name: 'ListarVentasEntregadas',
  components: {
    VentasListaCarritoEntregadas
    // Header2
  },
  data: function () {
    return {
    }
  }
}
</script>

<style>

</style>
